var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78033 7.28033C5.07322 6.98744 5.07322 6.51256 4.78033 6.21967L2.45208 3.89142C2.37398 3.81332 2.37398 3.68668 2.45208 3.60858L4.78033 1.28033C5.07322 0.987437 5.07322 0.512563 4.78033 0.21967C4.48744 -0.073223 4.01256 -0.073223 3.71967 0.21967L0.896446 3.04289C0.505922 3.43342 0.505921 4.06658 0.896445 4.45711L3.71967 7.28033C4.01256 7.57322 4.48744 7.57322 4.78033 7.28033Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.d389b546cf7cf6d5247afd5347c87bd3.svg";
export { ForwardRef as ReactComponent };